import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import PuiButton from "../../../components/elements/PuiButton";
import styles from "./Error.module.css";

export default function Error() {
    const history = useHistory();
    const { pathname } = useLocation();

    const handleBackToHome = () => {
        let path = "/homepage";
        if (pathname.startsWith("/studio/"))
            path = "/studio/homepage";
        history.push(path);
    };

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>404 NOT FOUND</h1>
            <div>お探しのページが見つかりませんでした。</div>
            <div
                style={{ width: "250px", height: "50px", textAlign: "center", margin: "40px auto 0" }}
            >
                <PuiButton onClick={handleBackToHome}>ホームに戻る</PuiButton>
            </div>
        </div>
    );
}